/**
 * Geogrid Type Mapping Constants
 *
 * Maps uppercase product family names (extracted from selectedGeogrid string)
 * to the mixed-case "family" field values used in dropdown options.
 *
 * Source of truth: src/app/data/geogrid-products-unified.json
 *
 * Usage:
 *   import { GEOGRID_TYPE_MAPPING } from '@/app/constants/geogridTypeMapping';
 *   const dropdownValue = GEOGRID_TYPE_MAPPING[extractedType.toUpperCase()] || extractedType;
 *
 * Context:
 *   - Product names are stored uppercase (e.g., "PARALINK 1600")
 *   - Dropdown options expect mixed case (e.g., "ParaLink")
 *   - This mapping converts between the two formats
 */

export const GEOGRID_TYPE_MAPPING: Record<string, string> = {
    'PARALINK': 'ParaLink',
    'PARAGRID HF': 'ParaGrid HF',
    'PARAGRID W': 'ParaGrid W',
    'MACGRID EG': 'MacGrid EG',
    'MACGRID EG T': 'MacGrid EG T',
    'MACGRID WG': 'MacGrid WG',
    'MACTEX C2': 'MacTex C2',
    'MACTEX W2': 'MacTex W2',
    'MULTICOMPOSITE': 'Multicomposite',
    'GEOTEXTILE': 'GEOTEXTILE',
};

/**
 * Converts an extracted uppercase type to the dropdown-compatible mixed-case format.
 *
 * @param extractedType - The uppercase type extracted from product name (e.g., "PARALINK")
 * @returns The mixed-case dropdown value (e.g., "ParaLink"), or the original if not mapped
 */
export const mapGeogridTypeToDropdownValue = (extractedType: string): string => {
    return GEOGRID_TYPE_MAPPING[extractedType.toUpperCase()] || extractedType;
};
